import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  SCHEDULE_APPOINTMENT_REQUEST,
  SCHEDULE_APPOINTMENT_SUCCESS,
  SCHEDULE_APPOINTMENT_FAILURE,
} = TherapistAction;

function* scheduleAppointment(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.scheduleAppointment,
      action.payload
    );
    if (response?.status === 200 || response?.status === 201) {
      yield put({ type: SCHEDULE_APPOINTMENT_SUCCESS, payload: response.data });
    } else {
      console.error('Unexpected response status:', response?.status);
      throw response.data;
    }
  } catch (error) {
    console.error('Schedule Appointment Error:', error);
    yield put({ type: SCHEDULE_APPOINTMENT_FAILURE, payload: error });
  }
}

function* scheduleAppointmentSaga() {
  yield takeEvery(SCHEDULE_APPOINTMENT_REQUEST, scheduleAppointment);
}

export default scheduleAppointmentSaga;

